import { RouterProvider } from 'react-router-dom'

import { DetailOverlayHost } from './components/DetailOverlayHost'
import { RecoveryBoundary } from './components/RecoveryBoundary'
import { AppProviders } from './providers'
import { router } from './routes'

export function App() {
  return (
    // RecoveryBoundary no topo: captura ChunkLoadError de lazy route (index
    // velho pós-deploy pedindo chunk que sumiu) e dispara recovery silencioso
    // com anti-loop, em vez de tela branca. Ver components/RecoveryBoundary.tsx.
    <RecoveryBoundary>
      <AppProviders>
        <RouterProvider router={router} />
        {/*
         * Pilha de overlays da ficha, IRMÃ do RouterProvider (fora da árvore
         * roteada) — a origem roteada nunca desmonta enquanto há overlay. Dentro
         * de AppProviders pra que as camadas (P1/P2) herdem Tier/Brand/i18n. Em
         * P0 é inerte (pilha vazia); só instala o árbitro de Back global.
         * Ver docs/plan/tv-ficha-overlay.md.
         */}
        <DetailOverlayHost />
      </AppProviders>
    </RecoveryBoundary>
  )
}
